module.exports = __webpack_public_path__ + "img/disconnected.d3baf133.png";